const CONDITION_GROUP_FRAGMENT = `
  fragment conditionGroup on ConditionGroup {
    operator
    conditions {
      operator
      firstNode {
        type
        value
      }
      secondNode {
        type
        value
      }
    }
  }
`

const FIELD_IMAGE = `
    image {
        url
        height
        width
    }
`
const FORM_FIELD_FRAGMENT = `
    ${CONDITION_GROUP_FRAGMENT}
    fragment field on Field {
        ... on BaseField {
            label
            code
            type
            labelHidden
            description
            validators {
                type
            }
            ${FIELD_IMAGE}
        }
        ... on RatableField {
            ratingMax
            ratingMinDescription
            ratingMaxDescription
        }
        ... on RatingField {
            ratingType
            ratingDescriptions
            layout
        }
        ... on CsatField {
            ratingDescriptions
        }
        ... on CheckBox {
            minChoices
            maxChoices
        }
        ... on SelectableField {
            choicesRandom
            choicesStyle
            choicesSize
            rowChoiceCount
            choices {
                label
                value
                type
            }
        }
        ... on TextArea {
            placeholder
            screenshotsEnabled
        }
        ... on TextField {
            placeholder
        }
        ... on EndingField {
            description
            content
            autoCloseEnabled
            autoCloseDuration
        }
        ... on WelcomeField {
            content
            buttonText        
        }
        ... on CtaField {
            choices {
                label
                value
                type
            }
            primaryButtonLink
            secondaryButtonLink
            buttonAlign
        }
        ... on ShowRuleControllableField {
            showRules {
                targets
                conditionGroup {
                  ...conditionGroup
                }
            }
        }
        ... on JumpRuleControllableField {
          jumpRule {
            targetType
            subRules {
              conditionGroup {
                ...conditionGroup
              }
              targetType
            }
          }
        }
    }
`

export const PublishedCampaignForm = `
    query publishedCampaignForm($campaignId: ID!, $cusd: String, $customerUid: String, $mode: PublishedEntryMode, $skipEntryId: Boolean = false, $isUrlVisit: Boolean = false) {
      campaignForm(campaignId: $campaignId) {
        token
        publishedEntryId(mode: $mode, cusd: $cusd, customerUid: $customerUid, isUrlVisit: $isUrlVisit) @skip(if: $skipEntryId)
        setting(cusd: $cusd) {
            colorScheme {
                accent
                background
            }
            buttonStyle {
                variant
                borderRadius
            }
            textStyle {
                align
            }
            brandingUrl
            localeSetting {
                locale
                wordings {
                    submitButton
                    nextButton
                    branding
                    ratingDescription {
                        like
                        love
                        dislike
                        neutral
                        hate
                    }
                    screenshotDescription {
                        inProgress
                        captured
                        screenshot
                    }
                    otherChoicePlaceholder
                }
            }
            showProgressBar
        }
        nextFields {
          totalCount
          startIndex
          nodes { ...field }
          isLastPage
        }
      }
    }
    ${FORM_FIELD_FRAGMENT}
`

export const PatchPublishedEntryMutation = `
    mutation patchPublishedEntry($formId: ID!, $publishedEntryId: ID!, $fieldEntries: [PublishedFieldEntryInput!]!) {
        patchPublishedEntry(input: {
            formId: $formId,
            publishedEntryId: $publishedEntryId,
            fieldEntries: $fieldEntries
        }) {
             nextFields {
                nodes { ...field }
                totalCount
                startIndex
                isLastPage
            }
        }
    }
    ${FORM_FIELD_FRAGMENT}
`
export const ExpirePublishedEntryMutation = `
    mutation expirePublishedEntry($formId: ID!, $publishedEntryId: ID!) {
        expirePublishedEntry(input: {
            formId: $formId,
            publishedEntryId: $publishedEntryId
        })
    }
`

export const CreateAttachmentUploadOptionsMutation = `
    mutation createAttachmentUploadOptions($publishedEntryId: ID!, $fieldCode: String!, $fileName: String) {
      createAttachmentUploadOptions(input: {
        publishedEntryId: $publishedEntryId,
        fieldCode: $fieldCode,
        fileName: $fileName
      }) {
        key
        url
      }
    }
`
